<script setup lang="ts">
import { computed, ref } from "vue";
import { useApiClient } from "@/api/client";
import { toastApiResult } from "@/toaster";
import { useRoute, useRouter } from "vue-router";
import { useBaseStore } from "@/stores/base";
import Modal from "@/ui/components/modal.vue";
const router = useRouter();

const passwordRules = ref([(v: string) => !!v || "Password is required"]);

const password = ref("");
const showPassword = ref(false);
const validPassword = ref(false);

const props = defineProps({
	isVisible: {
		type: Boolean,
		require: true,
	},
	onSuccess: {
		type: Function,
		required: false,
	},
});

const visible = computed({
	get() {
		return props.isVisible;
	},
	set(newValue) {
		if (!newValue) {
			closeDialog();
		}
	},
});

const emit = defineEmits(["close-dialog"]);
const closeDialog = () => {
	emit("close-dialog");
};

const confirmPassword = async () => {
	const response = await toastApiResult(
		useApiClient("users").confirmPassword(password.value)
	);
	if (response.isOk()) {
		emit("close-dialog");
		if (props.onSuccess) {
			props.onSuccess();
		}
	}
};

const cancel = () => {
	router.push("/home");
};

const logout = async () => {
	const response = await useApiClient("users").logout();
	if (response.isOk()) {
		useBaseStore().isAuthenticated = false;
		window.location.href = "/login";
	}
};
</script>

<template>
	<modal
		v-model="visible"
		title="Provide Password"
		icon="fa-solid fa-lock-keyhole"
		width="400px"
		:allow-submit="validPassword"
	>
		<v-form v-model="validPassword">
			<v-text-field
				v-model="password"
				label="Password"
				:rules="passwordRules"
				required
				:append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
				hide-details
				:type="showPassword ? 'text' : 'password'"
				@click:append-inner="showPassword = !showPassword"
			/>
		</v-form>
		<template #actions>
			<v-btn
				variant="tonal"
				color="error"
				prepend-icon="mdi-logout"
				@click="logout"
			>
				Log Out</v-btn
			>
			<v-spacer />
			<v-btn variant="text" color="error" @click="cancel"> Cancel </v-btn>
			<v-btn variant="flat" color="secondary" @click="confirmPassword">
				Confirm
			</v-btn>
		</template>
	</modal>
</template>

<style scoped lang="scss"></style>
